$background-primary: #111111;

.ShinyLoader {
    position: absolute;
    z-index: 3 !important;
    top: 0;
    left: 0;
    overflow: hidden;
    width: 100%;
    height: 100%;
    background-color: $background-primary !important;
    transition: opacity 1000ms ease-in-out;
    opacity: 1;
    pointer-events: auto;

    &.isLoaded {
        opacity: 0;
        pointer-events: none;
    }

    &:after {
        content: '';
        position: absolute;
        top: 0;
        left: -150%;
        width: 150%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.6), transparent);
        animation: shimmer 2s infinite;
        opacity: 0.2;
    }

    @keyframes shimmer {
        100% {
            left: 150%;
        }
    }
}
